/*
 *Filename: /home/codestax/MyMedicine/MyMed_Frontend/src/store/opdHospitalState.js *
 *Path: /home/codestax/MyMedicine/MyMed_Frontend                               *
 *Created Date: Tuesday, March 19th 2024, 11:05:49 am                          *
 *Author: Prakersharya                                                         *
 *                                                                             *
 *Copyright (c) 2024 Trinom Digital Pvt Ltd                                    *
 */


import Fuse from 'fuse.js';
import { axios_auth_instance_hba_customer, base_axios_instance_hospital_customer } from '../utils/axios_utils';
const initialState = {
    fetchingData: true,
    fetchedSuccessfuly: false,
    hospitalList: [],
    filterRegions: [],
    filteredHospitalList: [],
    showHospitalList: [],
    fetchingDoctorData: true,
    fetchingDoctorSuccefully: false,
    doctorListDoctorFlow: [],
    showDoctorListDoctorFlow: [],
    filteredDoctorListDoctorFlow: [],
    filterdSpeciality: [],
};

const opdHospitalState = {
    state() {
        return initialState;
    },
    getters: {
        getFilteredHospitalList(state) {
            return state.filteredHospitalList;
        },
        getNonFilteredHospitalList(state) {
            return state.hospitalList;
        },
        getDoctorListDoctorFlow(state) {
            return state.doctorListDoctorFlow;
        },
        getFilteredDoctorList(state) {
            return state.filteredDoctorListDoctorFlow;
        },
    },
    mutations: {
        makeFetchingDataTrue(state) {
            state.fetchingData = true;
        },
        makeFetchingDataFalse(state) {
            state.fetchingData = false;
        },
        makeFetchedSuccessFulyTrue(state) {
            state.fetchedSuccessfuly = true;
        },
        makeFetchingDoctorDataTrue(state) {
            state.fetchingDoctorData = true;
        },
        makeFetchingDoctorDataFalse(state) {
            state.fetchingDoctorData = false;
        },
        makeFetchedDoctorSuccessFulyTrue(state) {
            state.fetchingDoctorSuccefully = true;
        },
        uploadDoctorListDoctorFlow(state, doctorListDoctorFlow) {
            state.doctorListDoctorFlow = doctorListDoctorFlow;
        },
        uploadHospitalList(state, hospitalList) {
            state.hospitalList = hospitalList;
        },
        uploadFilteredHospitalList(state, hospitalList) {
            state.filteredHospitalList = hospitalList;
        },
        uploadFilteredDoctorList(state, doctorList) {
            state.filteredDoctorListDoctorFlow = doctorList;
        },
        uploadShowHospitalList(state, hospitalList) {
            state.showHospitalList = hospitalList;
        },
        uploadShowDoctorListDoctorFlow(state, DoctorListDoctorFlow) {
            state.showDoctorListDoctorFlow = DoctorListDoctorFlow;
        },
        uploadRegionFilter(state, regions) {
            state.filterRegions = regions;
        },
        resetState(state) {
            Object.keys(initialState).forEach(key => {
                state[key] = initialState[key];
            });
        },
        uploadSpecialityFilter(state, speciality) {
            state.filterdSpeciality = speciality;
        },
    },
    actions: {
        async loadHospitalList(context, payload) {
            try {
                let apiResponse = null;
                apiResponse = await axios_auth_instance_hba_customer.get('/opd');
                let hosList = [];
                hosList = apiResponse.data.hospitalList;
                context.commit('makeFetchingDataTrue');
                context.commit('uploadHospitalList', hosList);
                context.commit('uploadFilteredHospitalList', hosList);
                context.commit('uploadShowHospitalList', hosList);
                context.commit('makeFetchingDataFalse');
                context.commit('makeFetchedSuccessFulyTrue');
                // setTimeout(() => {
                //     context.commit('makeFetchingDataFalse');
                //     context.commit('makeFetchedSuccessFulyTrue');
                //     context.commit('uploadHospitalList', hosList);
                //     context.commit('uploadFilteredHospitalList', hosList);
                //     context.commit('uploadShowHospitalList', hosList);
                // }, 2000)
            } catch(error) {
                console.log(error);
            }
        },
        async addDoctorSpecialityFilterDoctorFlow(context, payload) {
            try {
                let actualDoctorList = context.getters.getDoctorListDoctorFlow;
                let selectedSpecialityIdList = payload.specialities;
                context.commit('uploadSpecialityFilter', selectedSpecialityIdList);
                selectedSpecialityIdList = selectedSpecialityIdList.map((item) => (item.id));
                if (selectedSpecialityIdList.length != 0) {
                    actualDoctorList = actualDoctorList.filter((item) => (selectedSpecialityIdList.includes(item.doctorInfo.doctorSpecialty)));
                }
                context.commit('uploadFilteredDoctorList', actualDoctorList);
                context.commit('uploadShowDoctorListDoctorFlow', actualDoctorList);
            } catch (error) {
                console.log('Error While fetching hospital info', error);
            }
        },
        async loadDoctorListDoctorFlow(context, payload) {
            try {
                if(context.getters.getDoctorListDoctorFlow.length != 0) return;
                let apiResponse = null;
                apiResponse = await axios_auth_instance_hba_customer.get('/opd/doctorList');
                let docList = [];
                docList = apiResponse.data.doctorList;
                context.commit('makeFetchingDoctorDataTrue');

                context.commit('uploadDoctorListDoctorFlow', docList);
                context.commit('uploadFilteredDoctorList', docList);
                context.commit('uploadShowDoctorListDoctorFlow', docList);
                context.commit('makeFetchingDoctorDataFalse');
                context.commit('makeFetchedDoctorSuccessFulyTrue');
                setTimeout(() => {

                }, 2000)
            } catch(error) {
                console.log(error);
            }
        },
        searchHospital(context, payload) {
            console.dir(payload, context.getters.getFilteredHospitalList);
            const options = {
                keys: ['name'],
                includeScore: true // This can be omitted if the score is not needed
            };
              const fuse = new Fuse(context.getters.getFilteredHospitalList, options);
              let ans = fuse.search(payload.searchQuery).map(result => result.item);
              context.commit('uploadShowHospitalList', ans);
        },
        searchDoctorDoctorFlow(context, payload) {
            console.dir(payload, context.getters.getFilteredDoctorList);
            const options = {
                keys: ['doctorInfo.doctorNameEN'],
                includeScore: true // This can be omitted if the score is not needed
            };
              const fuse = new Fuse(context.getters.getFilteredDoctorList, options);
              let ans = fuse.search(payload.searchQuery).map(result => result.item);
              console.log(ans);
              context.commit('uploadShowDoctorListDoctorFlow', ans);
        },
        removeSearchQuery(context) {
            context.commit('uploadShowHospitalList', context.getters.getFilteredHospitalList);
        },
        removeSearchQueryDoctor(context) {
            context.commit('uploadShowDoctorListDoctorFlow', context.getters.getFilteredDoctorList);
        },
        applyRegionFilter(context, payload) {
            context.commit('uploadRegionFilter', payload.regions);
            if(payload.regions.length == 0) {
                context.commit('uploadFilteredHospitalList', context.getters.getNonFilteredHospitalList)
                context.commit('uploadShowHospitalList', context.getters.getNonFilteredHospitalList);
            } else {
                let filteredAns = context.getters.getNonFilteredHospitalList.filter((item) => {
                    console.log(typeof(item.stateID), typeof(payload.regions[0]))
                    console.log(payload.regions.includes(item.stateID));
                    if(payload.regions.includes(Number(item.stateID))) return true;
                    return false;
                }) 
                console.log(filteredAns, payload.regions);
                context.commit('uploadFilteredHospitalList', filteredAns);
                context.commit('uploadShowHospitalList', filteredAns);

            }
        },
        resetOPDHospitalState(context) {
            context.commit('resetState');
        }
    },
};
export default opdHospitalState;